import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const o = a((c, e) => /* @__PURE__ */ s.jsx(
  l,
  {
    ref: e,
    ...c,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...r,
        children: [
          /* @__PURE__ */ s.jsxs(
            "mask",
            {
              id: "mask0_2974_4160",
              width: 21,
              height: 32,
              x: 14,
              y: 8,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: [
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M32.36 15.37H16.65c-1.46 0-2.65 1.18-2.65 2.64v19.34c0 1.46 1.19 2.65 2.65 2.65h15.71c1.46 0 2.64-1.19 2.64-2.64V18.01c0-1.46-1.19-2.64-2.64-2.64m1.14 21.98c0 .63-.51 1.14-1.14 1.14H16.65c-.63 0-1.15-.51-1.15-1.14V18.01c0-.63.51-1.15 1.15-1.15h15.71c.63 0 1.14.51 1.14 1.15zM20.98 13.69c.41 0 .75-.34.75-.75V9.5h5.53v3.44c0 .41.34.75.75.75s.75-.34.75-.75V8.75c0-.41-.34-.75-.75-.75h-7.03c-.41 0-.75.34-.75.75v4.19c0 .41.34.75.75.75"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M25.97 24.73c-1.62 0-2.97 1.17-3.26 2.71-1.71.37-3 1.89-3 3.72 0 2.09 1.7 3.79 3.79 3.79s3.79-1.7 3.79-3.79c0-.02-.01-.04-.01-.06a3.33 3.33 0 0 0 2.01-3.04 3.32 3.32 0 0 0-3.32-3.33m-2.47 8.72c-1.26 0-2.29-1.03-2.29-2.29s1.03-2.29 2.29-2.29 2.29 1.03 2.29 2.29-1.03 2.29-2.29 2.29m3.44-3.87a3.82 3.82 0 0 0-2.67-2.14c.25-.7.92-1.21 1.71-1.21 1 0 1.82.82 1.82 1.82-.01.63-.34 1.2-.86 1.53M22.08 25.16c1.31 0 2.37-1.06 2.37-2.37s-1.06-2.37-2.37-2.37-2.37 1.06-2.37 2.37 1.06 2.37 2.37 2.37m0-3.24a.87.87 0 1 1-.001 1.741.87.87 0 0 1 .001-1.741"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4160)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M-.207 0h48.555v48H-.207z" }) })
        ]
      }
    )
  }
));
o.displayName = "AgencyCleanserIcon";
export {
  o as AgencyCleanserIcon,
  o as default
};
//# sourceMappingURL=index.js.map
